import { useEffect, useMemo } from 'react';
import { debounce } from 'lodash';

export default function useDebounce(fn, delay) {
  const debounceFn = useMemo(
    (...args) => {
      return debounce(fn, delay || 500, ...args);
    },
    [fn, delay]
  );

  useEffect(() => {
    return () => debounceFn.cancel();
  }, [debounceFn]);

  return debounceFn;
}
